import React from 'react'
import { ArrowForward } from '@mui/icons-material'
import { Grid, Typography } from '@mui/material'
import { connect } from 'react-redux'
import * as common from '../../appRedux/actions/common'
import useStyles from './styles'

function Header(props) {
    const classes = useStyles()
    let redirectLink = props.redirectLink || ''
    const comebackFunc = () => props.redirectAction(redirectLink)

    return (
        <React.Fragment>
            <Grid className={classes.gridIcon}>
                {redirectLink ? <ArrowForward
                    fontSize='large'
                    onClick={() => comebackFunc()} /> : ''}
            </Grid>
            <Grid className={classes.root}>
                <Typography variant='h1'>
                    {props.title || 'title'}
                </Typography>
            </Grid>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        redirectAction: (route) => dispatch(common.redirectAction(route))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
